import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import BaseBonusInfoTable from 'components/BaseBonusInfoTable/BaseBonusInfoTable.jsx'
import { getReserveTableColumns } from 'components/BaseBonusInfoTable/columns.js'
import { FOOTER_RESERVES_NOTES } from 'components/BaseBonusInfoTable/translations'
import Warning from 'components/Warning/Warning.jsx'
import IndustrialResource from 'components/IndustrialResource/IndustrialResource.jsx'

import { MODERNIZATION_OVERLAY_TITLE } from 'components/ModernizationOverlay/constants.jsx'
import {
    RESERVE_TYPE_MESSAGES,
    UPGRADE_COST_HEADER,
    PERMISSIONS_REQUIRED_MESSAGE,
    UPGRADE_DESCRIPTION,
    MAX_LEVEL_MESSAGE,
} from './constants.jsx'

import { RESERVE_TITLES } from 'helpers/i18n.jsx'
import { MAX_BUILDING_LEVEL, RESERVE_TYPES } from 'constants'

import styles from './UpgradeEffectContent.scss'

export const UpgradeEffectContent = ({
    bonus,
    reserveType,
    reserveName,
    upgradeCosts,
    currentLevel,
    hasPermission,
}) => {
    const minBonus = bonus.values[0]

    const tableColumns = getReserveTableColumns(reserveType, minBonus, bonus.type)

    tableColumns.push({
        title: UPGRADE_COST_HEADER(true),
        dataIndex: 'upgradeCost',
        isCalculatedWidth: reserveType === RESERVE_TYPES.ARTILLERY_STRIKE,
        render: (value) => {
            return (
                <IndustrialResource
                    value={value}
                    small
                />
            )
        },
    })

    const dataSource = bonus.values.map((bonusParameters, index) => ({
        ...bonusParameters,
        upgradeCost: upgradeCosts[index],
    }))

    const isMaxLevelReached = (currentLevel === MAX_BUILDING_LEVEL)

    return (
        <div className={styles.base}>
            <div className={styles.header}>
                <h2 className={styles.title}>
                    <span className={styles.titleText}>
                        {MODERNIZATION_OVERLAY_TITLE}
                    </span>
                </h2>
                {!hasPermission && !isMaxLevelReached && (
                    <div className={styles.warning}>
                        <Warning type='warning'>{PERMISSIONS_REQUIRED_MESSAGE}</Warning>
                    </div>
                )}
                <div className={styles.description}>
                    {isMaxLevelReached ? MAX_LEVEL_MESSAGE : UPGRADE_DESCRIPTION(reserveName)}
                </div>
            </div>
            <div className={styles.content}>
                <div className={styles.bonusHolder}>
                    <BaseBonusInfoTable
                        classNames={{
                            title: styles.tableTitle,
                        }}
                        title={RESERVE_TYPE_MESSAGES[reserveType]}
                        footer={FOOTER_RESERVES_NOTES[reserveType]}
                        columns={tableColumns}
                        dataSource={dataSource}
                        selectedRow={currentLevel - 1}
                    />
                </div>
            </div>
        </div>
    )
}

UpgradeEffectContent.propTypes = {
    reserveType: PropTypes.string.isRequired,
    bonus: PropTypes.object.isRequired,
    reserveName: PropTypes.object.isRequired,
    upgradeCosts: PropTypes.arrayOf(PropTypes.number).isRequired,
    currentLevel: PropTypes.number.isRequired,
    hasPermission: PropTypes.bool.isRequired,
}

export const mapStateToProps = (state, ownProps) => {
    const { settings, slots, buildings, account } = state

    const slotId = parseInt(ownProps.slotId)
    const slot = slots[slotId]
    const building = buildings[slot.building]
    const reserveType = settings.buildings[building.type].reserve_type
    const reserveInfo = settings.reserves[reserveType]

    const upgradeCosts = settings.buildings[building.type].costs
    const hasPermission = (account.permissions.manage_building === true)
    return {
        upgradeCosts,
        hasPermission,
        reserveType,
        currentLevel: building.level,
        bonus: reserveInfo.bonus,
        reserveName: RESERVE_TITLES[reserveInfo.type],
    }
}

export default connect(
    mapStateToProps
)(UpgradeEffectContent)



// WEBPACK FOOTER //
// ./containers/BuildingCard/components/UpgradeEffectContent/UpgradeEffectContent.jsx